import React from 'react';
import SEO from '../components/SEO';

const Sventes = () => {
  return (
    <div>
      <SEO 
        title="Šventės"
        description="Šventės Sporto Krante - gimtadieniai, jubiliejai, giminės šventės gamtos apsuptyje. Privati erdvė, jauki atmosfera, profesionalus aptarnavimas."
        keywords="šventės, gimtadieniai, jubiliejai, giminės šventės, renginiai gamtoje, sporto krantas"
        canonicalUrl="https://sportokrantas.lt/sventes"
      />
      {/* Hero Section - White background, heading centered, body left-aligned */}
      <section className="py-12 border-b-[3px] border-black bg-white">
        <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8">
          <h1 className="text-black mb-6 tracking-wide leading-tight text-center" style={{ fontSize: '29.5px', fontWeight: 700, WebkitTextStroke: '0.5px' }}>
            ŠVENTĖS ARTIMIAUSIEMS - GIMINĖS JUBILIEJAI IR GIMTADIENIAI „SPORTO KRANTE"
          </h1>
          <div className="space-y-2 text-black leading-relaxed mb-2">
            <p>
              Giminės jubiliejai ir gimtadieniai – tai progos, kai svarbiausia buvimas kartu, ramus laikas su artimaisiais ir šventė be skubėjimo. „Sporto krantas" kviečia šias akimirkas paminėti jaukioje aplinkoje, kur gamta, erdvė ir privatumas leidžia susitelkti į tai, kas svarbiausia – žmones.
            </p>
            <p>
              Siūlome erdves šventėms tiek mažesnėms, tiek didesnėms giminės ar draugų kompanijoms. Čia galima ramiai pabūti, švęsti savo tempu, dalintis prisiminimais, mėgautis bendru stalu ir neskubriu bendravimu. Aplinka pritaikyta tiek aktyvesniam laisvalaikui, tiek ramesniems pasisėdėjimams.
            </p>
            <p>Esant poreikiui, galime pasirūpinti:</p>
          </div>
          
          {/* Bullet list */}
          <ul className="list-disc pl-8 space-y-1 text-black mb-2">
            <li>apgyvendinimu svečiams,</li>
            <li>maitinimo organizavimu (pusryčiais, pietumis ar vakariene),</li>
            <li>pirtimi, sūkurine vonia ar masažais,</li>
            <li>laisvalaikio veiklomis teritorijoje ar prie ežero.</li>
          </ul>
          
          <div className="space-y-2 text-black leading-relaxed mb-8">
            <p>
              Šventės „Sporto krante" dažnai tampa ne tik viena diena, bet nedideliu šeimos savaitgaliu, kai yra laiko pasikalbėti, pailsėti ir pabūti drauge be skubos.
            </p>
            <p>
              Čia gimtadieniai ir jubiliejai įgauna ramią, jaukią ir tikrą formą – tokią, kurią norisi prisiminti ir pakartoti.
            </p>
          </div>

          {/* 3 images in a row */}
          <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
            <div className="aspect-[4/3] overflow-hidden">
              <img 
                src="/img/sventes-1.jpg" 
                alt="Šventės" 
                className="w-full h-full object-cover hover:scale-105 transition-transform duration-300"
              />
            </div>
            <div className="aspect-[4/3] overflow-hidden">
              <img 
                src="/img/sventes-2.jpg" 
                alt="Šventės erdvė" 
                className="w-full h-full object-cover hover:scale-105 transition-transform duration-300"
              />
            </div>
            <div className="aspect-[4/3] overflow-hidden">
              <img 
                src="/img/sventes-3.jpg" 
                alt="Vakarienė" 
                className="w-full h-full object-cover hover:scale-105 transition-transform duration-300"
              />
            </div>
          </div>
        </div>
      </section>

      {/* Vestuvės Section - Black background, text left 70%, image right 30% */}
      <section className="border-b-[3px] border-black" style={{ backgroundColor: '#111315' }}>
        <div className="grid grid-cols-1 lg:grid-cols-10">
          {/* Content - 70% */}
          <div className="lg:col-span-7 px-8 py-12 lg:py-16 lg:px-12 flex flex-col justify-center">
            <h2 className="text-white mb-6 tracking-wide leading-tight text-center" style={{ fontSize: '24px', fontWeight: 700, WebkitTextStroke: '0.3px' }}>
              Vestuvės „Sporto krante" - tikra šventė be skubėjimo
            </h2>
            <div className="space-y-2 text-white leading-relaxed mb-4">
              <p>
                Erdvi, gamtos apsupta teritorija ant ežero kranto leidžia vestuves švęsti savo tempu – nuo pasiruošimo dienos iki lėto ryto po šventės. Čia vestuvės dažnai tampa vestuvių savaitgaliu, kai yra laiko pabūti su šeima ir draugais, pasimėgauti gamta, pirtimi ir ramiu bendravimu.
              </p>
              <p>„Sporto krantas" tinka:</p>
            </div>
            <ul className="list-disc pl-5 space-y-1 text-white mb-4">
              <li>nedidelėms ir vidutinėms vestuvėms,</li>
              <li>poroms, ieškančioms ne miesto šurmulio, o ramios aplinkos,</li>
              <li>šventėms be perteklinio formalumo, bet su kokybe ir estetika.</li>
            </ul>
            <div className="text-white leading-relaxed mb-4">
              <p>Esant poreikiui, galime padėti su:</p>
            </div>
            <ul className="list-disc pl-5 space-y-1 text-white">
              <li>apgyvendinimu jauniesiems ir svečiams,</li>
              <li>maitinimo organizavimu per patikimus tiekėjus,</li>
              <li>pirties ir SPA erdvėmis,</li>
              <li>teritorijos pritaikymu ceremonijai ar vakarui,</li>
              <li>ramiu, apgalvotu šventės organizavimo procesu.</li>
            </ul>
          </div>

          {/* Image - 30% */}
          <div className="lg:col-span-3 min-h-[400px] overflow-hidden">
            <img 
              src="/img/sventes-4.jpg" 
              alt="Vestuvės" 
              className="w-full h-full object-cover"
            />
          </div>
        </div>
      </section>

      {/* KOKYBIŠKAS POILSIS Section - White background, image left 30%, text right 70% */}
      <section className="border-b-[3px] border-black bg-white">
        <div className="grid grid-cols-1 lg:grid-cols-10">
          {/* Image - 30% */}
          <div className="lg:col-span-3 min-h-[400px] overflow-hidden">
            <img 
              src="/img/sventes-5.jpg" 
              alt="Apgyvendinimas" 
              className="w-full h-full object-cover"
            />
          </div>

          {/* Content - 70%, centered */}
          <div className="lg:col-span-7 px-8 py-12 lg:py-16 lg:px-12 flex flex-col justify-center items-center text-center">
            <div className="max-w-lg">
              <h2 className="text-black mb-6 tracking-wide leading-tight" style={{ fontSize: '24px', fontWeight: 700, WebkitTextStroke: '0.3px' }}>
                KOKYBIŠKAS POILSIS IR APGYVENDINIMAS
              </h2>
              <div className="space-y-2 text-black leading-relaxed">
                <p>
                  Komplekse įrengta 13 šviesių, modernaus dizaino kambarių – dviviečių ir šeimyninių, tinkamų tiek jauniesiems, tiek artimiausiems šeimos nariams ar svečiams. Kambariai sukurti taip, kad po šventės būtų galima iš tikrųjų pailsėti: patogios lovos, ramybė, tvarka ir jaukumas.
                </p>
                <p>
                  Pro kambarių langus atsiveria ežero arba miško vaizdai, kurie ypač vertinami po intensyvios šventės dienos. Rytas „Sporto krante" – lėtas ir šviesus, puikiai tinkantis ramiems pusryčiams, pokalbiams ir šventės pratęsimui be skubos.
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* SPA POILSIS Section - Gold background, text left 70%, image right 30% */}
      <section className="border-b-[3px] border-black" style={{ backgroundColor: '#D0AB64' }}>
        <div className="grid grid-cols-1 lg:grid-cols-10">
          {/* Content - 70%, centered text */}
          <div className="lg:col-span-7 px-8 py-12 lg:py-16 lg:px-12 flex flex-col justify-center items-center text-center">
            <div className="max-w-lg">
              <h2 className="text-black mb-6 tracking-wide leading-tight" style={{ fontSize: '24px', fontWeight: 700, WebkitTextStroke: '0.3px' }}>
                SPA POILSIS VESTUVIŲ IR GIMTADIENIŲ SVEČIAMS
              </h2>
              <div className="space-y-2 text-black leading-relaxed">
                <p>
                  Šventės „Sporto krante" – tai ne tik vakaras prie stalo, bet ir galimybė atsipalaiduoti, pabūti kartu ir pasimėgauti kokybišku poilsiu. Todėl SPA erdvė tampa ypatinga vestuvių ir gimtadienių šventės dalimi – tiek jauniesiems, tiek svečiams.
                </p>
                <p>
                  Pirtis ir atpalaiduojanti sūkurinė vonia leidžia ramiai užbaigti šventinę dieną arba pradėti ją lėtu, maloniu ritmu. Šiluma, tyla ir vaizdai į gamtą pro langus natūraliai padeda atsipalaiduoti po šurmulio, pokalbių ir šokių.
                </p>
                <p>
                  Norintiems išskirtinės patirties, siūlome profesionalaus pirtininko vedamus pirties ritualus, kurie suteikia gilesnį atsipalaidavimą ir tampa jaukia, bendra patirtimi mažesnei svečių grupei.
                </p>
              </div>
            </div>
          </div>

          {/* Image - 30% */}
          <div className="lg:col-span-3 min-h-[400px] overflow-hidden">
            <img 
              src="/img/sventes-6.jpg" 
              alt="SPA" 
              className="w-full h-full object-cover"
            />
          </div>
        </div>
      </section>

      {/* ERDVĖS LAUKE Section - Black background, heading centered, body left-aligned */}
      <section className="py-12 border-b-[3px] border-black" style={{ backgroundColor: '#111315' }}>
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
          <h2 className="text-white mb-6 tracking-wide leading-tight text-center" style={{ fontSize: '24px', fontWeight: 700, WebkitTextStroke: '0.3px' }}>
            ERDVĖS LAUKE - VESTUVĖMS IR ŠVENTĖMS GAMTOJE
          </h2>
          <div className="space-y-2 text-white leading-relaxed mb-2">
            <p>
              Šventės gamtoje turi ypatingą atmosferą – daugiau erdvės, šviesos ir laisvės būti savimi. „Sporto krantas" siūlo lauko erdves vestuvėms ir įvairioms šventėms, kuriose gamta tampa natūraliu šventės fonu, o kiekviena akimirka – lengva ir tikra.
            </p>
            <p>
              Teritorija ant ežero kranto puikiai tinka vestuvių ceremonijoms po atviru dangumi, jaukiems šventiniams susibūrimams ar vakarui su artimaisiais. Erdves galima pritaikyti pagal šventės viziją – nuo minimalistinės ceremonijos iki ilgesnio šventimo gamtoje.
            </p>
            <p>Lauko erdvėse galima:</p>
          </div>
          
          {/* Bullet list */}
          <ul className="list-disc pl-8 space-y-1 text-white">
            <li>organizuoti vestuvių ceremoniją ar svečių pasitikimą,</li>
            <li>įrengti stalus, poilsio zonas ar šventinę vakarienę,</li>
            <li>kurti jaukią atmosferą su apšvietimu, dekoracijomis ir gyva muzika.</li>
          </ul>
        </div>
      </section>
    </div>
  );
};

export default Sventes;
